import PluginScreen from "./PluginScreen";

export default PluginScreen;